export type PasskeyFeatureFlagInput = {
  signInRetroUIEnabled?: boolean;
  passkeySignInBypassEnabled?: boolean;
  passkeyRegistrationEnabled?: boolean;
  passkeyDeletionEnabled?: boolean;
  passkeyKillSwitchEnabled?: boolean;
  signInRetroUIEnabledWeb?: boolean;
  passkeySignInBypassWebEnabled?: boolean;
  passkeyKillSwitchWebEnabled?: boolean;
  passkeyDeletionEnabledWeb?: boolean;
  enableUsernameTransmitWeb?: boolean;
} | null;

export type PlatformPasskeyFlags = {
  retroSignInUi: boolean;
  bypassPasskeySignIn: boolean;
  registrationEnabled: boolean;
  deletionEnabled: boolean;
  sdkEnabled: boolean;
};

export type WebPasskeyFlags = PlatformPasskeyFlags & {
  passUsernameToTransmit: boolean;
};

export type ResolvedPasskeyFeatureFlags = {
  app: PlatformPasskeyFlags;
  web: WebPasskeyFlags;
};

type PasskeyFeatureFlagFields = Exclude<PasskeyFeatureFlagInput, null>;

const readPasskeyFlags = (
  featureFlagging?: object | null
): PasskeyFeatureFlagFields => {
  if (!featureFlagging || !('passkey' in featureFlagging)) {
    return {};
  }

  const passkey = featureFlagging.passkey;
  if (!passkey || typeof passkey !== 'object') {
    return {};
  }

  return passkey as PasskeyFeatureFlagFields;
};

/**
 * Missing restriction flags stay off. Missing registration and deletion flags
 * stay allowed. A kill switch forces retro sign-in and blocks registration,
 * deletion, and SDK startup for that platform.
 */
export const resolvePasskeyFeatureFlags = (
  featureFlagging?: object | null
): ResolvedPasskeyFeatureFlags => {
  const raw = readPasskeyFlags(featureFlagging);
  const killApp = raw?.passkeyKillSwitchEnabled === true;
  const killWeb = raw?.passkeyKillSwitchWebEnabled === true;

  return {
    app: {
      retroSignInUi: killApp || raw?.signInRetroUIEnabled === true,
      bypassPasskeySignIn: killApp || raw?.passkeySignInBypassEnabled === true,
      registrationEnabled: !killApp && raw?.passkeyRegistrationEnabled !== false,
      deletionEnabled: !killApp && raw?.passkeyDeletionEnabled !== false,
      sdkEnabled: !killApp,
    },
    web: {
      retroSignInUi: killWeb || raw?.signInRetroUIEnabledWeb === true,
      bypassPasskeySignIn:
        killWeb || raw?.passkeySignInBypassWebEnabled === true,
      registrationEnabled: !killWeb,
      deletionEnabled: !killWeb && raw?.passkeyDeletionEnabledWeb !== false,
      sdkEnabled: !killWeb,
      passUsernameToTransmit: raw?.enableUsernameTransmitWeb === true,
    },
  };
};
